import Card from '../components/common/Card'

const DashboardPage = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold text-gray-900">Dashboard</h2>
        <p className="text-gray-600 mt-2">Traffic analysis dashboard and reporting</p>
      </div>

      <Card>
        <div className="text-center py-12">
          <h3 className="text-xl font-semibold text-gray-900 mb-2">Dashboard Under Construction</h3>
          <p className="text-gray-600">Traffic analysis features will be available here soon.</p>
        </div>
      </Card>
    </div>
  )
}

export default DashboardPage
